import { gql } from '@apollo/client';

const query = gql`
  query GetEnquiries(
    $categoryId: String
    $suburbName: String
    $state: String
    $region: String
  ) {
    enquiries(
      suburbName: $suburbName
      state: $state
      region: $region
      categoryId: $categoryId
    ) {
      edges {
        node {
          listingId
          suburbName
          state
          listing {
            name
            hash
            profileUrl
            vanityUrlPath
            online
          }
        }
      }
    }
  }
`;

module.exports = query;
